import React from "react";

export default function TrustpilotInline({ className = "" }) {
	return (
		<a
			className={`trustpilot-inline ${className}`.trim()}
			href="https://uk.trustpilot.com/review/edyn.care"
			target="_blank"
			rel="noopener noreferrer"
			aria-label="Read Edyn Care reviews on Trustpilot"
		>
			<span className="trustpilot-inline__rating">Excellent</span>
			<span className="trustpilot-inline__stars" aria-hidden="true">
				{[1, 2, 3, 4, 5].map((star) => (
					<span key={star}>&#9733;</span>
				))}
			</span>
			<span className="trustpilot-inline__score">
				<span>111 reviews</span> on
			</span>
			<span className="trustpilot-inline__brand">
				<span aria-hidden="true">&#9733;</span>
				Trustpilot
			</span>
		</a>
	);
}
